(() => {

  window.PrimeDecoHeader = {

    getWishlistCount() {
      try {
        return (
          JSON.parse(
            localStorage.getItem('primedeco-wishlist')
          ) || []
        ).length;
      } catch {
        return 0;
      }
    },

    updateWishlistBadges() {

      const count = this.getWishlistCount();

      document
        .querySelectorAll('[data-pd-wishlist-count]')
        .forEach(el => {

          el.textContent = count;

          el.hidden = count === 0;

        });

    },

    updateCartBadges() {

      fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {

        document
          .querySelectorAll('[data-pd-cart-count]')
          .forEach(el => {

            el.textContent = cart.item_count;

            el.hidden = cart.item_count === 0;

          });

      });

    },
escapeHTML(value = '') {
  const element = document.createElement('div');
  element.textContent = value;
  return element.innerHTML;
},

formatMoney(cents) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: window.Shopify?.currency?.active || 'EUR'
  }).format((Number(cents) || 0) / 100);
},

initSearch() {
  const drawer = document.querySelector('[data-pd-search-drawer]');
  const overlay = document.querySelector('[data-pd-search-overlay]');
  const input = document.querySelector('[data-pd-search-input]');
  const results = document.querySelector('[data-pd-search-results]');
  const toggles = document.querySelectorAll('[data-pd-search-toggle]');
  const close = document.querySelector('[data-pd-search-close]');
  const clear = document.querySelector('[data-pd-search-clear]');

  if (!drawer || !overlay || !input || !results) return;

  let timer;

  const openSearch = () => {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.classList.add('df-search-open');
    drawer.setAttribute('aria-hidden', 'false');

    setTimeout(() => input.focus(), 100);
  };

  const closeSearch = () => {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.classList.remove('df-search-open');
    drawer.setAttribute('aria-hidden', 'true');
  };

  const renderResults = (data, term) => {
    const resources = data?.resources?.results || {};
    const products = resources.products || [];
    const collections = resources.collections || [];
    const queries = resources.queries || [];

    if (
    !products.length &&
    !collections.length &&
    !queries.length
) {
    results.innerHTML = `
        <p class="df-search-results__message">
            Aucun résultat trouvé.
        </p>

        <a
            class="df-search-view-all"
            href="/search?q=${encodeURIComponent(term)}"
        >
            Voir tous les résultats
        </a>
    `;

    return;
}

    let html = '';

    if (queries.length) {
      html += `
        <section class="df-search-group">
          <h3>Suggestions</h3>
          ${queries.map(item => `
            <a
              class="df-search-link"
              href="/search?q=${encodeURIComponent(item.text)}"
            >
              ${this.escapeHTML(item.styled_text || item.text)}
            </a>
          `).join('')}
        </section>
      `;
    }

    if (products.length) {
      html += `
        <section class="df-search-group">
          <h3>Des produits</h3>

          ${products.map(product => `
            <a
              class="df-search-product"
              href="${this.escapeHTML(product.url)}"
            >
              ${
                product.image
                  ? `<img
                       src="${this.escapeHTML(product.image)}"
                       alt="${this.escapeHTML(product.title)}"
                       loading="lazy"
                     >`
                  : ''
              }

              <span>
                <span class="df-search-product__title">
                  ${this.escapeHTML(product.title)}
                </span>

                <span class="df-search-product__price">
                  ${this.formatMoney(product.price)}
                </span>
              </span>
            </a>
          `).join('')}
        </section>
      `;
    }

    if (collections.length) {
      html += `
        <section class="df-search-group">
          <h3>Collections</h3>

          ${collections.map(collection => `
            <a
              class="df-search-link"
              href="${this.escapeHTML(collection.url)}"
            >
              ${this.escapeHTML(collection.title)}
            </a>
          `).join('')}
        </section>
      `;
    }

    html += `
      <section class="df-search-group">
        <a
          class="df-search-view-all"
          href="/search?q=${encodeURIComponent(term)}"
        >
          Voir tous les résultats pour « ${this.escapeHTML(term)} »
        </a>
      </section>
    `;

    results.innerHTML = html;
  };

  const search = async (term) => {
    results.innerHTML =
      '<p class="df-search-results__message">Recherche…</p>';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const url =
`${root}search/suggest.json` +
`?q=${encodeURIComponent(term)}` +
`&resources[type]=product,collection,query` +
`&resources[limit]=4` +
`&resources[options][unavailable_products]=hide`;

      const response = await fetch(url, {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error('Recherche impossible');
      }

      const data = await response.json();
      renderResults(data, term);
    } catch (error) {
      console.error(error);

      results.innerHTML =
        '<p class="df-search-results__message">Aucun résultat disponible.</p>';
    }
  };

  toggles.forEach(button => {
    button.addEventListener('click', openSearch);
  });

  close?.addEventListener('click', closeSearch);
  overlay?.addEventListener('click', closeSearch);

document.addEventListener('click', event => {
  const clickedOutsideSearch =
    drawer.classList.contains('is-open') &&
    !event.target.closest('[data-pd-search-drawer]') &&
    !event.target.closest('[data-pd-search-toggle]');

  if (clickedOutsideSearch) {
    closeSearch();
  }
});

  clear?.addEventListener('click', () => {
    input.value = '';
    results.innerHTML =
      '<p class="df-search-results__message">Commencez à saisir votre recherche.</p>';
    input.focus();
  });

  input.addEventListener('input', () => {
    clearTimeout(timer);

    const term = input.value.trim();

    if (term.length < 2) {
      results.innerHTML =
        '<p class="df-search-results__message">Saisissez au moins 2 caractères.</p>';
      return;
    }

    timer = setTimeout(() => search(term), 250);
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      closeSearch();
    }
  });
},
    init() {

      this.updateWishlistBadges();

      this.updateCartBadges();

      this.initSearch();

      window.addEventListener(
        'storage',
        () => this.updateWishlistBadges()
      );

      document.addEventListener(
        'cart:refresh',
        () => this.updateCartBadges()
      );

      document.addEventListener('click', (event) => {
  if (
    event.target.closest('[data-pd-wishlist-button]') ||
    event.target.closest('[data-pd-wishlist-remove]')
  ) {
    setTimeout(
      () => this.updateWishlistBadges(),
      100
    );
  }
});

    }

  };

  document.addEventListener(
    'DOMContentLoaded',
    () => PrimeDecoHeader.init()
  );

})();